import { createTheme } from '@mui/material/styles';
import { responsiveFontSizes } from "@mui/material/styles";

export const getTheme = (mode) => {
  return responsiveFontSizes(
    createTheme({
      palette: {
        mode,
        primary: {
          main: '#35be70',
          light: '#5bc98b',
          dark: '#279955',
          contrastText: '#ffffff',
        },
        background: {
          default: mode === 'light' ? '#ededed' : '#222222',
        },
      },
      typography: {
        fontSize: 13,
        subtitle1: {
          fontWeight: 'bold',
        },
      },
    })
  )
}
